import { useIntl } from "react-intl";
import { useFormContext } from "react-hook-form";

import testIds from "constants/testIds";
import { ReactComponent as PackageCheckIcon } from "assets/images/iconsV2/package-check.svg";
import { ReactComponent as PackageUpIcon } from "assets/images/iconsV2/package-up.svg";
import { StopType } from "types/MultiStop";
import { stopTestId } from "@RequestFormV2/utils/testIds";
import { getStopFieldPath } from "@RequestFormV2/sections/Schedule/utils/fieldPaths";
import { useStopPlanning } from "@RequestFormV2/sections/Schedule/hooks/useStopPlanning";
import { useStopContact } from "@RequestFormV2/sections/Schedule/hooks/useStopContact";
import AddressSection from "@RequestFormV2/sections/Schedule/components/StopCard/AddressSection";
import ContactSection from "@RequestFormV2/sections/Schedule/components/StopCard/ContactSection";
import ScheduleSection from "@RequestFormV2/sections/Schedule/components/StopCard/ScheduleSection";
import StopHeader from "@RequestFormV2/sections/Schedule/components/StopCard/StopHeader";

interface StopCardProps {
  index: number;
  isMultiStop: boolean;
  canRemove: boolean;
  onDuplicate: (index: number) => void;
  onRemove: (index: number) => void;
}

export default function StopCard({ index, isMultiStop, canRemove, onDuplicate, onRemove }: StopCardProps) {
  const intl = useIntl();
  const { watch } = useFormContext();
  const planning = useStopPlanning(index);
  const contact = useStopContact(index);

  const stopType = watch(getStopFieldPath(index, "stop_type"));
  const isPickup = stopType === StopType.PICKUP;

  const title = isPickup
    ? intl.formatMessage({ id: "general.pickup", defaultMessage: "Pickup" })
    : intl.formatMessage({ id: "general.delivery", defaultMessage: "Delivery" });

  const TitleIcon = isPickup ? PackageUpIcon : PackageCheckIcon;

  return (
    <div
      className="rfv2-schedule-stop"
      data-testid={stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTAINER_PREFIX, index)}
    >
      {isMultiStop ? (
        <StopHeader index={index} canRemove={canRemove} onDuplicate={onDuplicate} onRemove={onRemove} />
      ) : (
        <h3 className={`rfv2-schedule-stop__title rfv2-schedule-stop__title--${isPickup ? "pickup" : "delivery"}`}>
          <TitleIcon className="rfv2-schedule-stop__title-icon" />
          {title}
        </h3>
      )}
      <AddressSection
        stopIndex={index}
        setAddressBookTimezone={planning.setAddressBookTimezone}
        setPortTimezone={planning.setPortTimezone}
      />
      <ScheduleSection planning={planning} stopIndex={index} />
      <ContactSection contact={contact} stopIndex={index} />
    </div>
  );
}
